import { FunctionComponent } from "react";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Footer from "../../../components/footer";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ProviderNotFoundImage from "../../../assets/images/provider-not-found.png";
import ProviderNotFoundImageWebp from "../../../assets/images/provider-not-found.webp";
import VectorWrapper from "../../../components/vector-wrapper";
import useLoadImage from "../../../utils/useLoadImage";
import LoadingScreen from "../../general/loading-screen";
import HeadingContainer from "../../../layout/heading-container";
import { HeadlineMedium } from "../../../components/font";
import { Button } from "@manifesthhqinc/ui-library";

const ProviderKnownScreen: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const { currentSourceAccountStep, onClickContinue, isSaving, setIsSaving } = props;
  const { imageSrc, webpSrc } = useLoadImage({
    imgSrc: ProviderNotFoundImage,
    webp: ProviderNotFoundImageWebp,
  });

  const onClickContinueHandler = () => {
    setIsSaving(true);
    onClickContinue();
  };

  if (process.env.NODE_ENV !== "test" && !imageSrc && !webpSrc) {
    return <LoadingScreen loadingScreenMessage="" />;
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar>
            <HeadlineMedium $textAlign="center">
              We’ll verify your old <br />
              account details for you!
            </HeadlineMedium>
          </HeadingContainer>
          <VectorWrapper
            imgSrc={imageSrc}
            webpSrc={webpSrc}
            imgAlt={`provider-search-vector`}
            name={`provider-search-vector`}
          />
        </Container>
      </ScrollableContainer>
      <Footer>
        <p className="text-center form-description-with-vector disclaimer-text no-max-width">
          Manifest uses trusted resources to confirm your old account details. Our database search ensures all
          information is up to date.
        </p>
        <Button name="continue" onClick={onClickContinueHandler} isLoading={isSaving} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ProviderKnownScreen;
